import {useQuery} from "@apollo/client";
import {GetCategoriesAdmin} from "./Category.js";

export function useGetCategoriesAdmin(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetCategoriesAdmin,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetCategoriesAdmin']) ? data : previousData;
    const extracted = (holder) ? holder['GetCategoriesAdmin'] : [];

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetCategoriesAdmin(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetCategoriesAdmin,
        variables
    });
    const extracted = data ? data['GetCategoriesAdmin'] : [];
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
